<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>End cash tracking</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="end()">
        <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

</ion-header>

<ion-content>
  <ion-grid class="form">
    <ion-row>
      <ion-col>
        <div class="warning-box">
          <p>Are you sure you want to end cash tracking? Any cash movements will be cleared.</p>
        </div>
      </ion-col>
    </ion-row>
    @if (permissionService.isPermitted('pos-cash-tracking-print-cash-tracking-report') && printer_paper_sizes && printer_paper_sizes.length > 0) {
      <ion-row style="margin-top: 25px; text-align: center;">
        <ion-col>
          @if (printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal')) {
            <span id="print_cash_tracking_report" style="cursor: pointer; color: var(--ion-color-primary)"><fa-icon [icon]="['fal', 'print']" style="margin-right:5px;"></fa-icon>Print cash tracking report</span>
            <ion-popover trigger="print_cash_tracking_report" [dismissOnSelect]="true" side="bottom">
              <ng-template>
                <ion-list lines="full">
                  <ion-item button="true" (click)="printCashTrackingReport('a4')">
                    <ion-label><fa-icon [icon]="['fal', 'file-invoice']" size="lg" [fixedWidth]="true"></fa-icon>A4</ion-label>
                  </ion-item>
                  <ion-item button="true" (click)="printCashTrackingReport('thermal')">
                    <ion-label><fa-icon [icon]="['fal', 'receipt']" size="lg" [fixedWidth]="true"></fa-icon>Thermal</ion-label>
                  </ion-item>
                </ion-list>
              </ng-template>
            </ion-popover>
          }
          @if (printer_paper_sizes.includes('a4') && !printer_paper_sizes.includes('thermal')) {
            <span style="cursor: pointer; color: var(--ion-color-primary)" (click)="printCashTrackingReport('a4')"><fa-icon [icon]="['fal', 'print']" style="margin-right:5px;"></fa-icon>Print cash tracking report</span>
          }
          @if (!printer_paper_sizes.includes('a4') && printer_paper_sizes.includes('thermal')) {
            <span style="cursor: pointer; color: var(--ion-color-primary)" (click)="printCashTrackingReport('thermal')"><fa-icon [icon]="['fal', 'print']" style="margin-right:5px;"></fa-icon>Print cash tracking report</span>
          }
        </ion-col>
      </ion-row>
    }
  </ion-grid>

</ion-content>